import appTickets from "../../views/appSettings/tickets.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "tickets";
  const params = ["page", "limit"];

  $stateProvider.state("tickets", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appTickets,
      },
    },
    reloadOnSearch: false,
    data: { title: "Tickets" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/tickets/tickets.urls.js